import { Injectable } from '@angular/core';
import { BaseService } from '../../../../../../../shared/services/base.service';
import { Utility } from '../../../../../../../common/utility';
import { ConsultationUrl } from '../../../../../../../shared/urls/consultation.url';

@Injectable()
export class RecommendedPrescriptionInfoService {
    constructor(private baseService: BaseService) {
    }

    getPrescriptions(groupId) {
        const url = Utility.stringFormat(ConsultationUrl.ADD_RECOMMEND_PRESCRIPTION, [groupId]);
        return this.baseService.getData(url, { isHistory: true });
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/recommended-prescription-info/recommended-prescription-info.service.ts